class scrollHelper{
	constructor() {
		
	}
	to(el, tar, buff) {
		$(el).click(function (e) {
			e.preventDefault();
			var target = typeof tar === 'undefined' ? $(this).attr('href') : tar,
				buffer = typeof buff === 'undefined' ? parseInt($('body').css('margin-top')) : buff,
				scrollDest = parseInt($(target).offset().top - buffer);
			$('html, body').animate({
				scrollTop: scrollDest,
			}, 1000);
		});
	}
	toggleClassOnScroll(el) {
		let threshold = el.getAttribute('data-scroll-threshold');
		let upClass = el.getAttribute('data-up-class');
		let target = document.querySelector(el.getAttribute('data-target')) || el;
		let scrollable = window;
		this.debouncedEventHandle(scrollable, () => {
			target.classList.toggle(upClass, (scrollable.scrollY || scrollable.scrollTop) > threshold );
		}, 'scroll');
	}
	debouncedEventHandle(element, callback, event) {
		let hasRequestedWork = false;
		element.addEventListener(event, (e) => {
			if (!hasRequestedWork) {
				window.requestAnimationFrame(() => {
					callback();
					setTimeout(() => { 
						hasRequestedWork = false;
					}, 600);
				});
				hasRequestedWork = true;
			}
		});
	}
}
window.app.add('scroll', new scrollHelper());
